var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.section.ms_show_in_nav
    ? _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isScheduled && !_vm.isEmpty,
              expression: "isScheduled && !isEmpty",
            },
          ],
          ref: "menu_nav--btn_" + _vm.section.ms_id,
          staticClass: "menu_section_nav--button btn",
          class: { "btn-highlight": _vm.isHighlighted },
          attrs: {
            id: "menu_nav--btn_" + _vm.section.ms_id,
            href: "#" + _vm.section.ms_id + "-MS",
          },
        },
        [_vm._v(_vm._s(_vm.sectionNavTitle))]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }